import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "next", "submit"]

  connect() {
    this.update()
    this.element.addEventListener("input", () => this.update())
    this.element.addEventListener("change", () => this.update())
  }

  next(event) {
    event.preventDefault()
    const idx = this.nextTargets.indexOf(event.currentTarget)
    const nextSection = this.sectionTargets[idx + 1]
    if (!nextSection) return

    nextSection.classList.remove("d-none")
    nextSection.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  update() {
    this.nextTargets.forEach((button, idx) => {
      button.disabled = !this.sectionFilled(this.sectionTargets[idx])
    })

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.allSectionsFilled()
    }
  }

  sectionFilled(section) {
    const required = section.querySelectorAll("[data-wizard-required]")
    return Array.from(required).every(el => String(el.value || "").trim() !== "")
  }

  allSectionsFilled() {
    return this.sectionTargets.every(section => this.sectionFilled(section))
  }
}
